import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M46 16L56 32H10.5508L0 16L10.5508 0H56L46 16ZM9.58301 16L14.8584 24H41.5654L36.5664 16L41.5654 8H14.8584L9.58301 16Z'
const RAW_WIDTH = 56
const RAW_HEIGHT = 32

/**
 * Chevron Left cutout shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const ChevronLeftCutoutShape = React.forwardRef((props, ref) => {
    const {...rest} = props || {}

    return <CustomPath {...rest} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default ChevronLeftCutoutShape

